module.exports = __webpack_public_path__ + "img/why_sn_placeholder.4c80f13.png";